<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="mode === 'edit' ? 'Edit Guest' : 'Add Guest'"
      [canGoBack]="true"
      [noBow]="true"
      [showLinkIcon]="mode === 'edit'"
      [linkIcon]="'trash'"
      (linkAction)="deleteGuest()" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form">
    <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">
      @if (loaded) {
        <tidy-card>
          <tidy-row class="field-top-padding field-bottom-padding">
            <tidy-input
              formControlName="name"
              [form]="form.controls.name"
              [label]="'Full Name'"
              [errorMessage]="'Please enter the guest\'s name.'"
              [submitted]="submitted"
              [icon]="'assets/svg/person.svg'" />
          </tidy-row>
          <tidy-row class="field-bottom-padding">
            <tidy-input
              formControlName="email"
              [form]="form.controls.email"
              [label]="'Email'"
              type="email"
              [errorMessage]="'Please enter a valid email.'"
              [submitted]="submitted"
              [icon]="'assets/svg/mail.svg'" />
          </tidy-row>
          <tidy-row>
            <tidy-input-international-phone
              formControlName="phone"
              [form]="form.controls.phone"
              [label]="'Phone'"
              [inputMode]="'numeric'"
              [submitted]="submitted"
              [errorMessage]="'Please enter a valid phone.'"
              [icon]="'assets/svg/phone-portrait.svg'"
              [initialMask]="{ mask: '[00000000000000000000000]' }"
              (countryCodeChange)="onCountryCodeChange($event)" />
          </tidy-row>
        </tidy-card>

        @if (errorMessage) {
          <tidy-error-message [text]="errorMessage" />
        }

        <tidy-button
          [text]="mode === 'edit' ? 'Save Changes' : 'Add Guest'"
          [action]="boundSave"
          class="primary" />

        @if (mode === 'edit') {
          @if (canMessageGuest) {
            <tidy-button
              [text]="'Message Guest'"
              [action]="boundMessageGuest"
              class="secondary" />
          } @else {
            <tidy-row [align]="'center'" class="extra-top-padding">
              <tidy-text [helper]="'Add a phone number to message this guest.'" />
            </tidy-row>
          }
          <tidy-row [align]="'center'" class="extra-top-padding">
            <tidy-text
              [actionBody]="'Remove Guest'"
              (action)="deleteGuest()"
              class="link red" />
          </tidy-row>
        }
      }
    </tidy-wrapper>
  </form>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
